"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[9396],{

/***/ 8232:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export SidecartController */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4319);
/* harmony import */ var _core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8306);
/* harmony import */ var _core_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7516);
/* harmony import */ var _core_google_analytics_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6627);
/* harmony import */ var _theme_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8884);
/* harmony import */ var _customer_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5633);








class SidecartController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    "sidecart",
    "overlay",
    "cartItems",
    "emptyCartMessage",
    "cta",
    "ungroupedItemTemplate",
    "groupedItemsTemplate",
    "groupedItemTemplate",
    "behindMinQtyTemplate",
    "metMinQtyTemplate",
    "aboveMinQtyTemplate",
    "membershipBenefits",
    "membershipBenefit",
    "giftContainer",
    "giftForm",
    "giftCheckbox",
    "giftEmail",
    "giftNote",
    "feedbackContainer",
    "flashMessageTemplate",
    "disableOnUpdate",
    "scrollableContainer",
  ]

  GIFT_RECIPIENT_EMAIL_KEY = 'Recipient email'
  GIFT_MESSAGE_KEY = 'Message'
  GIFT_DISCOUNTS = ['SUBSCRIBER', 'THIS-IS-A-GIFT']

  static values = {
    subscriptionTag: String,
    giftEnabled: Boolean
  }

  static outlets = [ 'sidecart-stepper', 'byo', 'sidecart-recommendations' ]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('sidecart') === 'true') {
      this.open()
    }

    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeydown)

    this.fetchCart()

    this.debouncedGiftUpdate = (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.debounce)(this.handleGiftInput.bind(this), 600)
    if (this.hasGiftEmailTarget) {
      this.giftEmailTarget.addEventListener('input', this.debouncedGiftUpdate)
    }
    if (this.hasGiftNoteTarget) {
      this.giftNoteTarget.addEventListener('input', this.debouncedGiftUpdate)
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeydown)
    if (this.hasGiftEmailTarget) {
      this.giftEmailTarget.removeEventListener('input', this.debouncedGiftUpdate)
    }
    if (this.hasGiftNoteTarget) {
      this.giftNoteTarget.removeEventListener('input', this.debouncedGiftUpdate)
    }
  }

  handleKeydown(event) {
    if (this.sidecartTarget.dataset.open && event.key === 'Escape') {
      this.close()
    }
  }

  async cartId() {
    if (!this.cart?.id) {
      await this.fetchCart()
    }

    return this.cart.id
  }

  groupItemsByBundle(items) {
    return items.reduce((groups, item) => {
      const bundleId = item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value

      if (bundleId) {
        (groups[bundleId] = groups[bundleId] || []).push(item);
      }

      return groups;
    }, {});
  }

  async fetchCart() {
    const maxRetries = 5
    let retryCount = 0

    while (retryCount < maxRetries) {
      try {
        const cart = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].getCart(this.cart?.id)
        this.cart = cart["data"]["cart"]

        if (this.cart) {
          this.renderCart()
          this.renderGiftForm()
          this.updateByo()
          return
        } else {
          throw new Error('Cart data is null or undefined')
        }
      } catch (error) {
        retryCount++

        if (retryCount >= maxRetries) {
          console.error(`Failed to fetch cart after ${maxRetries} attempts:`, error)
          return
        }

        // Exponential backoff: 1s, 2s, 4s, 8s, 16s
        const delay = Math.pow(2, retryCount - 1) * 1000
        console.log(`Cart fetch failed (attempt ${retryCount}/${maxRetries}). Retrying in ${delay}ms...`)

        await new Promise(resolve => setTimeout(resolve, delay))
      }
    }
  }

  cartContainsSmallBundleItem() {
    return this.cart?.lines?.nodes?.some(item => this.isSmallBundle(item)) || false
  }

  minimumSleevesForCart() {
    if (!this.cart) {
      return _theme_constants__WEBPACK_IMPORTED_MODULE_5__.MINIMUM_SLEEVES_FOR_BUNDLE
    }

    // If the cart contains a small bundle SKU that is a subscription AND in a bundle, we can allow 1 sleeve as the min.
    const cartHasValidSmallBundleItem = this.cart.lines.nodes.some(item => this.isSmallBundle(item))

    if (cartHasValidSmallBundleItem) {
      return 1
    } else {
      return _theme_constants__WEBPACK_IMPORTED_MODULE_5__.MINIMUM_SLEEVES_FOR_BUNDLE
    }
  }

  isSmallBundle(item) {
    return _theme_constants__WEBPACK_IMPORTED_MODULE_5__.SKUS_THAT_ENABLE_SMALL_BUNDLES.includes(item?.merchandise?.sku) &&
      !!item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value &&
      !!item.sellingPlanAllocation?.sellingPlan?.name
  }

  goToCheckout() {
    if (!this.isGiftFormValidForCheckout()) {
      if (this.hasGiftEmailTarget) this.giftEmailTarget.reportValidity()
      return
    }
    window.location.href = '/checkout'
  }

  async setDiscountCodes(discountCodes) {
    if (!this.cart?.id) await this.fetchCart()
    await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].setCartDiscounts(this.cart.id, discountCodes)
  }

  async setCartAttributes(attributes) {
    await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].setCartAttributes(await this.cartId(), attributes)
  }

  itemsToBundle(items) {
    // Product ID is included in the _rc_bundle attribute after the colon, i.e. "uNYFy4Jfb:9072500146475"
    // Defaulting to the normal bundle in case that ever changes. 🤷‍♂️
    const externalProductId = items[0].attributes.find(attribute => attribute.key === '_rc_bundle')?.value?.split(':')[1] || _theme_constants__WEBPACK_IMPORTED_MODULE_5__.COFFEE_BUNDLE_PRODUCT_ID
    const externalVariantId = items[0].attributes.find(attribute => attribute.key === '_rc_bundle_variant')?.value
    const selections = items.map(item => ({
      collectionId: '473755812139',
      externalProductId: item.merchandise.product.id,
      externalVariantId: item.merchandise.id,
      quantity: item.quantity,
      sellingPlan: this.sellingPlanId(item),
    }))

    return {
      externalProductId,
      externalVariantId,
      selections
    }
  }

  async checkBundleValidity(bundle) {
    if (!bundle.selections) {
      bundle.selections = bundle.items
    }

    const meetsMinQty = bundle.selections.reduce((acc, item) => acc + item.quantity, 0) >= this.minimumSleevesForCart()
    const isBundleValid = await window.recharge.bundle.validateDynamicBundle(
      bundle
    )

    return isBundleValid === true && meetsMinQty
  }

  async updateCartFromTray(trayProducts) {
    // We need to find the differences between the bundle items and the tray products
    // and then update the cart accordingly, preferring to update quantities over adding new items.
    const bundleItems = this.firstBundleItems()

    const trayProductCounts = trayProducts.reduce((acc, product) => {
      acc[product.id] = (acc[product.id] || 0) + 1
      return acc
    }, {})

    let itemsToUpdate = []
    let itemsToAdd = []

    for (const bundleItem of bundleItems) {
      const productId = (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(bundleItem.merchandise.product.id)
      const trayQuantity = trayProductCounts[productId] || 0

      if (trayQuantity !== bundleItem.quantity) {
        itemsToUpdate.push({
          id: bundleItem.id,
          quantity: trayQuantity
        })
      }

      delete trayProductCounts[productId]
    }

    // Pull properties from an existing bundle item, as it contains important information
    // we'll need for adding new items to the cart.
    const itemToPullPropertiesFrom = bundleItems[0]
    const existingSellingPlanName = itemToPullPropertiesFrom?.sellingPlanAllocation?.sellingPlan?.name

    for (const [productId, quantity] of Object.entries(trayProductCounts)) {
      const product = trayProducts.find(p => p.id === productId)
      if (product) {
        const sellingPlanId = (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(product.sellingPlanGroups?.nodes?.[0]?.sellingPlans?.nodes?.find(sp => sp.name === existingSellingPlanName)?.id)
        const properties = itemToPullPropertiesFrom?.attributes?.filter(attribute => attribute.key !== '_selected_by')?.reduce((acc, attribute) => ({ ...acc, [attribute.key]: attribute.value }), {}) || {}
        properties['_selected_by'] = 'customer' // This update always comes from BYO, so we always assume customer.
        // This is new to the cart, so we'll need to add it.
        itemsToAdd.push({
          id: product.variantId,
          quantity: quantity,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}), // Only add selling_plan if it exists.
          properties: properties
        })
      }
    }

    if (itemsToUpdate.length > 0) {
      await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(this.cart.id, itemsToUpdate)
    }

    if (itemsToAdd.length > 0) {
      await this.addToCart(itemsToAdd)
    }

    await this.fetchCart()
  }

  async clearCart() {
    await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].clearCart(await this.cartId())
    await this.fetchCart()
  }

  getCurrentBundleQuantity(bundleId) {
    const bundleItems = this.cart.lines.nodes.filter(item =>
      item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value === bundleId
    )
    return bundleItems.reduce((total, item) => total + item.quantity, 0)
  }

  toggleDisableOnUpdate(disabled) {
    this.disableOnUpdateTargets.forEach(target => {
      target.dataset.disabled = disabled
    })
  }

  async updateBundleItemQuantity(event) {
    this.toggleDisableOnUpdate(true)
    const item = this.cart.lines.nodes.find(item => item.id === event.currentTarget.dataset.itemId)

    const bundleId = item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value
    const newQuantity = parseInt(event.currentTarget.dataset.updateQuantity)
    const currentBundleQuantity = this.getCurrentBundleQuantity(bundleId)

    // Calculate what the bundle quantity would be after this update
    const newBundleQuantity = currentBundleQuantity - item.quantity + newQuantity

    if (this.isSmallBundle(item) && newQuantity > 1) {
      // Re-enable the element since we're not proceeding with the update
      const message = `Oh no, you can add only 1 pack of this coffee to your bundle.`
      this.showError(message)

      this.toggleDisableOnUpdate(false)
      return
    }

    try {
      const res = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(await this.cartId(), [{ id: item.id, quantity: newQuantity }])

      this.cart = res["data"]["cartLinesUpdate"]["cart"]

      // Fire appropriate event based on quantity change
      if (newQuantity === 0) {
        this.prepareAndFireCartItemRemovedEvent(item, 'user_remove')
      } else {
        this.prepareAndFireCartItemQuantityUpdatedEvent(item, newQuantity)
      }

      this.renderCart()
      this.updateByo()
    } catch (error) {
      console.error('Failed to remove bundle item:', error)
      // Re-fetch the cart to ensure we have the latest state
      this.fetchCart()
    }
  }

  showError(message) {
    this.feedbackContainerTarget.innerHTML = ''
    const flashMessage = this.flashMessageTemplateTarget.content.cloneNode(true)
    flashMessage.querySelector(
      '[data-flash-target="text-content"]'
    ).textContent = message
    this.feedbackContainerTarget.appendChild(flashMessage)
    const flashMessageEl = this.feedbackContainerTarget.lastElementChild
    setTimeout(() => {
      flashMessageEl.classList.remove('opacity-0', 'scale-50', 'max-h-0')
    }, 0)

    setTimeout(async () => {
      flashMessageEl.classList.remove('max-h-10')
      flashMessageEl.classList.add('opacity-0', 'scale-50', 'max-h-0')
      await new Promise((resolve) => setTimeout(resolve, 150))
      this.feedbackContainerTarget.removeChild(flashMessageEl)
    }, 5000)
  }

  async removeItem(event) {
    this.toggleDisableOnUpdate(true)
    const itemId = event.currentTarget.dataset.itemId
    const item = this.cart.lines.nodes.find(item => item.id === itemId)

    try {
      const res = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].removeCartItems(await this.cartId(), [itemId])

      this.cart = res["data"]["cartLinesRemove"]["cart"]

      // Fire cart item removed event
      if (item) {
        this.prepareAndFireCartItemRemovedEvent(item, 'user_remove')
      }

      this.renderCart()
    } catch (error) {
      console.error('Failed to remove item:', error)
      // Re-fetch the cart to ensure we have the latest state
      this.fetchCart()
    }
  }

  firstBundleId() {
    return this.cart?.lines?.nodes?.find(item => item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value)?.attributes.find(attribute => attribute.key === '_rc_bundle')?.value
  }

  firstBundleItemsExpandedByQuantity() {
    return this.firstBundleItems().flatMap(item => Array(item.quantity).fill(item))
  }

  firstBundleItems() {
    // Return all bundle item IDs in the first bundle encountered in the cart.
    const firstBundleId = this.firstBundleId()

    if (!firstBundleId) {
      return []
    }

    return this.cart.lines.nodes.filter(item => item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value === firstBundleId)
  }

  async addItems(items) {
    // Read from the first bundle. If the item exists in the cart, update the quantity.
    // If the item does not exist in the cart, add it.
    const firstBundleItems = this.firstBundleItems()
    const itemsToUpdate = items.filter(item => firstBundleItems.some(cartItem => (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(cartItem.merchandise.id.toString()) === (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.id.toString())))
    const itemsToAdd = items.filter(item => !firstBundleItems.some(cartItem => (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(cartItem.merchandise.id.toString()) === (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.id.toString())))
    const totalQuantity = items.reduce((acc, item) => acc + item.quantity, 0) + firstBundleItems.reduce((acc, item) => acc + item.quantity, 0)
    const bundleId = firstBundleItems[0]?.attributes.find(attribute => attribute.key === '_rc_bundle')?.value.split(':')[1]

    // Only check bundle quantity limits if we have a bundle
    if (bundleId) {
      // If the item is a small bundle and we're trying to add more than 1, prevent the update and show an error.
      if (
        items.some(item =>
          this.isSmallBundle(item) &&
          itemsToUpdate.some(updateItem =>
            (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(updateItem.id.toString()) === (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.id.toString()) &&
            updateItem.quantity >= 1
          )
        )
      ) {
        this.showError(`Oh no, you can add only 1 pack of this coffee to your bundle.`)
        return
      }
    }

    if (itemsToUpdate.length > 0) {
      await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(await this.cartId(), itemsToUpdate.map(item => {
        const cartItem = firstBundleItems.find(cartItem => (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(cartItem.merchandise.id.toString()) === (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.id.toString()))

        return {
          id: cartItem.id,
          quantity: item.quantity + cartItem.quantity
        }
      }))
    }

    if (firstBundleItems.length > 0 && itemsToAdd.length > 0) {
      // Ensure any added items are added to the first bundle, if they were already being added as a bundle item.
      if (itemsToAdd[0].properties['_rc_bundle']) {
        for (const item of itemsToAdd) {
          item.properties['_rc_bundle'] = firstBundleItems[0].attributes.find(attribute => attribute.key === '_rc_bundle')?.value
          item.properties['_rc_bundle_variant'] = firstBundleItems[0].attributes.find(attribute => attribute.key === '_rc_bundle_variant')?.value
          item.properties['_rc_bundle_parent'] = firstBundleItems[0].attributes.find(attribute => attribute.key === '_rc_bundle_parent')?.value
        }
      }
    }

    if (itemsToAdd.length > 0) {
      try {
        return await this.addToCart(itemsToAdd)
      } catch (err) {
        console.error(err)
        return [] // No items added to cart
      }
    }
  }

  async addToCart(items) {
    const cartMachine = (0,_core_cart__WEBPACK_IMPORTED_MODULE_3__.getCartMachine)()

    return await new Promise((resolve, reject) => {
      cartMachine.addItems({
        resolve,
        reject,
        input: {
          items: items
        }
      })
    })
  }

  updateByo() {
    if (this.byoOutlets.length > 0) {
      this.byoOutlets.forEach(byo => byo.readBundleFromCart())
    }
  }

  sellingPlanId(item) {
    return this.sellingPlan(item)?.sellingPlan?.id
  }

  sellingPlan(item) {
    // SellingPlan API objects can bear a DeliveryPolicy. If that's present, we can match on that more reliably.
    const defaultInterval = "WEEK"
    const defaultIntervalCount = 4
    // Assumes the selling plan name is always "Delivery every 4 Weeks". We can
    // override this if we need to.
    const defaultSellingPlanName = "Delivery every 4 Weeks".toLowerCase()

    if (item.merchandise.sellingPlanAllocations.nodes) {
      // cart fragment and a subquery of product query go straight to nodes
      const matchingSellingPlan =
        item.merchandise.sellingPlanAllocations.nodes.find(node => node.sellingPlan?.deliveryPolicy?.interval === defaultInterval && node.sellingPlan?.deliveryPolicy?.intervalCount === defaultIntervalCount) ||
        item.merchandise.sellingPlanAllocations.nodes.find(node => node.sellingPlan.name.toLowerCase() === defaultSellingPlanName) ||
        item.merchandise.sellingPlanAllocations.nodes[0]
      return matchingSellingPlan
    } else if(item.merchandise.sellingPlanAllocations.edges) {
      // other queries, such as the product main query, pass through edges
      const matchingSellingPlan =
        item.merchandise.sellingPlanAllocations.edges.find(edge => edge.node.sellingPlan?.deliveryPolicy?.interval === defaultInterval && edge.node.sellingPlan?.deliveryPolicy?.intervalCount === defaultIntervalCount) ||
        item.merchandise.sellingPlanAllocations.edges.find(edge => edge.node.sellingPlan.name.toLowerCase() === defaultSellingPlanName) ||
        item.merchandise.sellingPlanAllocations.edges[0].node
      return
    }
  }

  async toggleSubscription(event) {
    this.toggleDisableOnUpdate(true)
    const items = this.cart.lines.nodes.filter(item => item.attributes.find(attribute => attribute.key === '_rc_bundle')?.value === event.currentTarget.dataset.bundleId)

    try {
      const res = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(await this.cartId(), items.map(item => ({
        id: item.id,
        sellingPlanId: event.currentTarget.checked ? this.sellingPlanId(item) : null
      })))

      this.cart = res["data"]["cartLinesUpdate"]["cart"]

      this.renderCart()
      this.updateByo()
    } catch (error) {
      console.error('Failed to update cart items:', error)
      // Re-fetch the cart to ensure we have the latest state
      this.fetchCart()
    }
  }

  imageForItem(item) {
    const productImage = item.merchandise.product.trayImage?.reference?.image?.url ||
      item.merchandise.product.roaster?.reference?.cometeerLogo?.reference?.image?.url ||
      item.merchandise.product.bundleImage?.reference?.image?.url ||
      item.merchandise.image.url

    return productImage
  }

  itemIsDiscoBox(item) {
    return item.merchandise.sku.includes('PP16PCDP') || item.merchandise.sku.includes('PP16PCJH')
  }

  capsuleCount(items) {
    return items.reduce((acc, item) => {
      // Extract the number from the variant title, default to 8 if no number is found
      // Supposed to support 4 packs and stuff, but it's a bit hacky.
      const capsule_count = item.merchandise.title.match(/\d+/) ? parseInt(item.merchandise.title.match(/\d+/)[0]) : 8
      return acc + (capsule_count * item.quantity)
    }, 0)
  }

  renderItems(groupedItems, ungroupedItems) {
    Object.entries(groupedItems).forEach(([bundleId, items]) => {
      const template = this.groupedItemsTemplateTarget.content.cloneNode(true)
      const total_price = items.reduce((acc, item) => acc + parseFloat(item.cost.totalAmount.amount), 0)
      const total_disco_box_price = items.filter(item => this.itemIsDiscoBox(item)).reduce((acc, item) => acc + parseFloat(item.cost.totalAmount.amount), 0)
      const total_original_price = items.reduce((acc, item) => acc + parseFloat(item.cost.compareAtAmountPerQuantity ? item.cost.compareAtAmountPerQuantity.amount * item.quantity : item.cost.subtotalAmount.amount), 0)
      const total_capsules = this.capsuleCount(items)

      const bundleIsSubscription = items.every(item => item.sellingPlanAllocation?.sellingPlan?.name)
      template.querySelector('[data-subscription-toggle]').checked = bundleIsSubscription
      template.querySelectorAll('[data-bundle-id]').forEach(el => el.dataset.bundleId = bundleId)

      if (total_original_price !== total_price) {
        template.querySelector('[data-price]').innerHTML = `<strike class="text-cometeer-medium-gray">${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(total_original_price * 100).replace(/\.00/g, '')}</strike> ${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(total_price * 100).replace(/\.00/g, '')}`
      } else {
        template.querySelector('[data-price]').textContent = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(total_price * 100).replace(/\.00/g, '')
      }

      const subscriptionTag = template.querySelector('[data-subscription-tag]')
      if (subscriptionTag) {
        const discountPrice = total_original_price - total_price
        const discountPriceFormatted = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(discountPrice * 100).replace(/\.00/g, '')

        // Don't show tag if discount is 0 and we're displaying the discount amount (as in - contains the {{discount}} placeholder)
        if (discountPrice === 0 && this.subscriptionTagValue.includes('{{discount}}')) {
          subscriptionTag.style.display = 'none'
        } else {
          subscriptionTag.style.display = 'block'
        }

        subscriptionTag.textContent = this.subscriptionTagValue.replace('{{discount}}', discountPriceFormatted)
      }

      const bundleHasDiscoBox = items.some(item => this.itemIsDiscoBox(item))
      const nextOrderDiscoBoxPrice = bundleHasDiscoBox ? 80 : 0
      const ppc = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)((total_price * 100) / total_capsules).replace(/\.00/g, '') // This orders price per cup
      const dcc = this.capsuleCount(items.filter(item => !this.itemIsDiscoBox(item))) + (bundleHasDiscoBox ? 40 : 0) // Next orders total capsules
      const dppc = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(
        (((total_price - total_disco_box_price) + nextOrderDiscoBoxPrice) / dcc) * 100
      ).replace(/\.00/g, '') // Next orders price per cup (bundle price - disco box price + next order disco box price) / total capsules in next order

      template.querySelectorAll('[data-benefit]').forEach(benefit => {
        // Hide benefits that are not applicable to the bundle type or content
        if (bundleIsSubscription && benefit.dataset.type === 'otp') {
          benefit.classList.add('hidden')
        } else if (!bundleIsSubscription && benefit.dataset.type === 'subscription') {
          benefit.classList.add('hidden')
        } else if (benefit.dataset.discoBoxRequirement === 'disco' && !bundleHasDiscoBox) {
          benefit.classList.add('hidden')
        } else if (benefit.dataset.discoBoxRequirement === 'normal' && bundleHasDiscoBox) {
          benefit.classList.add('hidden')
        } else {
          benefit.classList.remove('hidden')
        }

        // Replace text placeholders with actual values
        benefit.innerHTML = benefit.innerHTML.replace('{ppc}', ppc)
        benefit.innerHTML = benefit.innerHTML.replace('{dcc}', dcc)
        benefit.innerHTML = benefit.innerHTML.replace('{dppc}', dppc)
      })

      items.forEach(item => {
        const perQuantityPrice = (item.cost.totalAmount.amount * 100) / item.quantity
        const perQuantityOriginalPrice = (item.cost.subtotalAmount.amount * 100) / item.quantity

        const itemTemplate = this.groupedItemTemplateTarget.content.cloneNode(true)
        itemTemplate.querySelector('[data-image]').src = this.imageForItem(item)
        if (item.merchandise.product.productType === 'Mystery Sleeve') {
          itemTemplate.querySelector('[data-image]').classList.add('rounded-full')
        }
        const title = [
          item.merchandise.product.roaster?.reference?.name?.value,
          item.merchandise.product.title
        ].filter(i => i).join(" - ")
        itemTemplate.querySelector('[data-image]').alt = title
        itemTemplate.querySelector('[data-title]').textContent = title
        itemTemplate.querySelector('[data-quantity]').textContent = item.quantity
        itemTemplate.querySelector('[data-trash]').classList.toggle('hidden', item.quantity !== 1)
        itemTemplate.querySelector('[data-minus]').classList.toggle('hidden', item.quantity === 1)
        itemTemplate.querySelectorAll('[data-item-id]').forEach(el => el.dataset.itemId = item.id)
        itemTemplate.querySelector('[data-next-quantity]').dataset.updateQuantity = item.quantity + 1
        itemTemplate.querySelector('[data-previous-quantity]').dataset.updateQuantity = item.quantity - 1
        if (this.isSmallBundle(item)) {
          itemTemplate.querySelector('[data-next-quantity]').removeAttribute('data-action')
          itemTemplate.querySelector('[data-next-quantity]').classList.remove('cursor-pointer')
          itemTemplate.querySelector('[data-next-quantity] img').classList.add('opacity-25')
        }

        if (perQuantityOriginalPrice !== perQuantityPrice) {
          itemTemplate.querySelector('[data-price]').innerHTML = `<strike class="text-cometeer-medium-gray">${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityOriginalPrice).replace(/\.00/g, '')}</strike> ${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityPrice).replace(/\.00/g, '')}`
        } else {
          itemTemplate.querySelector('[data-price]').textContent = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityPrice).replace(/\.00/g, '')
        }

        template.querySelector('[data-bundle-items]').appendChild(itemTemplate)
      })

      const minQty = this.minimumSleevesForCart()
      const itemsQuantity = items.reduce((acc, item) => acc + item.quantity, 0)

      const behindMinQtyNeeded = minQty - itemsQuantity - (this.metMinQtyTemplateTargets.length > 0 ? 1 : 0)
      if (this.behindMinQtyTemplateTargets.length > 0 && behindMinQtyNeeded > 0) {
        for (let i = 0; i < behindMinQtyNeeded; i++) {
          const behindMinQtyTemplate = this.behindMinQtyTemplateTarget.content.cloneNode(true)
          template.querySelector('[data-bundle-items]').appendChild(behindMinQtyTemplate)
        }
      }

      if (this.metMinQtyTemplateTargets.length > 0 && itemsQuantity < minQty) {
        const metMinQtyTemplate = this.metMinQtyTemplateTarget.content.cloneNode(true)
        template.querySelector('[data-bundle-items]').appendChild(metMinQtyTemplate)
      }

      if (this.aboveMinQtyTemplateTargets.length > 0 && itemsQuantity < minQty + 1) {
        const aboveMinQtyTemplate = this.aboveMinQtyTemplateTarget.content.cloneNode(true)
        template.querySelector('[data-bundle-items]').appendChild(aboveMinQtyTemplate)
      }

      this.cartItemsTarget.appendChild(template)
    })

    ungroupedItems.forEach(item => {
      const template = this.ungroupedItemTemplateTarget.content.cloneNode(true)
      template.querySelector('[data-image]').src = this.imageForItem(item)
      if (item.merchandise.product.productType === 'Mystery Sleeve') {
        template.querySelector('[data-image]').classList.add('rounded-full')
      }
      const title = [
        item.merchandise.product.roaster?.reference?.name?.value,
        item.merchandise.product.title
      ].filter(i => i).join(" - ")
      template.querySelector('[data-image]').alt = title
      template.querySelector('[data-title]').textContent = title
      template.querySelector('[data-description]').textContent = item.merchandise.product.description.length > 50 ? item.merchandise.product.description.substring(0, 50) + '...' : item.merchandise.product.description
      template.querySelector('[data-item-id]').dataset.itemId = item.id

      const perQuantityPrice = (item.cost.totalAmount.amount * 100) / item.quantity
      const perQuantityOriginalPrice = (item.cost.subtotalAmount.amount * 100) / item.quantity

      if (perQuantityOriginalPrice !== perQuantityPrice) {
        template.querySelector('[data-price]').innerHTML = `<strike class="text-cometeer-medium-gray">${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityOriginalPrice).replace(/\.00/g, '')}</strike> ${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityPrice).replace(/\.00/g, '')}`
      } else {
        template.querySelector('[data-price]').textContent = (0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(perQuantityPrice).replace(/\.00/g, '')
      }

      this.cartItemsTarget.appendChild(template)
    })
  }

  hasBundleItems() {
    return this.cart.lines.nodes.some(item => item.attributes.find(attribute => attribute.key === '_rc_bundle'))
  }

  async renderCart() {
    if (!this.cart) {
      await this.fetchCart()
      // If we still don't have cart data after fetchCart, don't render
      if (!this.cart) {
        console.error("Could not fetch cart.")
        return
      }
    }

    this.cartItemsTarget.innerHTML = ''

    if (this.cart.totalQuantity > 0) {
      this.emptyCartMessageTarget.classList.add("hidden")
      this.cartItemsTarget.classList.remove("hidden")
      const groupedItems = this.groupItemsByBundle(this.cart.lines.nodes)
      const ungroupedItems = this.cart.lines.nodes.filter(item => !item.attributes.find(attribute => attribute.key === '_rc_bundle'))
      // Check bundle validity for each grouped bundle.
      const bundleValidities = await Promise.all(Object.values(groupedItems).map(async (items) => {
        return await this.checkBundleValidity(this.itemsToBundle(items))
      }))

      if (bundleValidities.some(validity => !validity)) {
        this.ctaTarget.disabled = true
        this.ctaTarget.innerHTML = "Add More Items"
      } else {
        this.ctaTarget.disabled = false
        this.ctaTarget.innerHTML = `<span class="mr-2">Checkout</span> • <span class="ml-2">${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(this.cart.cost.totalAmount.amount * 100)}</span>`
      }

      this.renderItems(groupedItems, ungroupedItems)
      if (this.hasGiftContainerTarget) {
        this.giftContainerTarget.classList.remove("hidden")
        this.renderGiftForm()
      }
    } else {
      this.emptyCartMessageTarget.classList.remove("hidden")
      this.cartItemsTarget.classList.add("hidden")
      this.ctaTarget.disabled = true
      this.ctaTarget.innerHTML = "Add More Items"
      if (this.hasGiftContainerTarget) {
        this.giftContainerTarget.classList.add("hidden")
      }
    }

    this.renderMembershipBenefits()
    this.updateStepperOutlet()
    this.updateRecommendationsOutlet()
    this.dispatchCartUpdatedEvent()
  }

  renderMembershipBenefits() {
    if (this.cart.totalQuantity > 0 && this.membershipBenefitTargets.length > 0) {
      this.membershipBenefitsTarget.classList.remove("hidden")
    } else if (this.cart.totalQuantity === 0 || this.membershipBenefitTargets.length === 0) {
      this.membershipBenefitsTarget.classList.add("hidden")
    }
  }

  renderGiftForm() {
    if (!this.hasGiftCheckboxTarget || !this.hasGiftFormTarget) return

    // Find if any line item has gift attributes set
    const giftLine = this.cart?.lines?.nodes?.find(item =>
      item.attributes.some(attr => attr.key === this.GIFT_RECIPIENT_EMAIL_KEY)
    )

    if (giftLine || this.giftEnabledValue) {
      this.giftCheckboxTarget.checked = true
      this.giftFormTarget.classList.remove('hidden')
      if (this.hasSidecartRecommendationsOutlet) this.sidecartRecommendationsOutletElement.parentElement.classList.add('hidden')
      // Pre-fill fields if present
      const emailAttr = giftLine?.attributes?.find(attr => attr.key === this.GIFT_RECIPIENT_EMAIL_KEY)
      const noteAttr = giftLine?.attributes?.find(attr => attr.key === this.GIFT_MESSAGE_KEY)
      if (this.hasGiftEmailTarget) this.giftEmailTarget.value = emailAttr?.value || ''
      if (this.hasGiftNoteTarget) this.giftNoteTarget.value = noteAttr?.value || ''
    } else {
      this.giftCheckboxTarget.checked = false
      this.giftFormTarget.classList.add('hidden')
      if (this.hasSidecartRecommendationsOutlet) this.sidecartRecommendationsOutletElement.parentElement.classList.remove('hidden')
      if (this.hasGiftEmailTarget) this.giftEmailTarget.value = ''
    }
  }

  async toggleGift(event) {
    if (event.currentTarget.checked) {
      this.giftFormTarget.classList.remove('hidden')
      this.giftEnabledValue = true
    } else {
      this.giftCheckboxTarget.disabled = true
      this.giftFormTarget.classList.add('hidden')
      this.giftEnabledValue = false
      await this.removeGiftDiscounts()
      await this.clearGiftAttributes()
      this.giftCheckboxTarget.disabled = false
    }
  }

  nonGiftAttributes(attributes) {
    return attributes.filter(attr =>
      ![this.GIFT_RECIPIENT_EMAIL_KEY, this.GIFT_MESSAGE_KEY, '__shopify_send_gift_card_to_recipient'].includes(attr.key)
    )
  }

  giftLineItemUpdates() {
    if (!this.cart) return []
    const email = this.giftEmailTarget?.value?.trim() || ''
    let note = this.giftNoteTarget?.value || ''
    const checked = this.giftCheckboxTarget?.checked
    const validEmail = checked && email && this.isValidGiftEmail(email)
    return this.cart.lines.nodes.map(item => {
      if (validEmail) {
        const giftAttributes = [
          ...this.nonGiftAttributes(item.attributes),
          { key: this.GIFT_RECIPIENT_EMAIL_KEY, value: email },
          { key: this.GIFT_MESSAGE_KEY, value: note }
        ]

        // Add the special Shopify attribute for gift cards
        if (item.merchandise.product.productType === 'Gift Card') {
          giftAttributes.push({ key: '__shopify_send_gift_card_to_recipient', value: 'true' })
        }

        return {
          id: item.id,
          attributes: giftAttributes
        }
      } else {
        // Remove gift attributes
        return {
          id: item.id,
          attributes: this.nonGiftAttributes(item.attributes)
        }
      }
    })
  }

  async handleGiftInput() {
    if (!this.cart) return
    if (!this.giftCheckboxTarget.checked) return
    const email = this.giftEmailTarget.value.trim()
    if (email && !this.isValidGiftEmail(email)) {
      this.giftEmailTarget.setCustomValidity('Please enter a valid email address')
      this.giftEmailTarget.reportValidity()
      return
    } else {
      this.giftEmailTarget.setCustomValidity('')
    }
    const updates = this.giftLineItemUpdates()
    try {
      await this.addGiftDiscounts()
      const res = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(this.cart.id, updates)
      this.cart = res["data"]["cartLinesUpdate"]["cart"]
    } catch (error) {
      console.error('Failed to update gift attributes:', error)
      this.fetchCart()
    }
  }

  async clearGiftAttributes() {
    if (!this.cart) return
    const updates = this.cart.lines.nodes.map(item => ({
      id: item.id,
      attributes: this.nonGiftAttributes(item.attributes)
    }))
    try {
      const res = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].updateCartItems(this.cart.id, updates)
      this.cart = res["data"]["cartLinesUpdate"]["cart"]
      this.renderCart()
    } catch (error) {
      console.error('Failed to clear gift attributes:', error)
      this.fetchCart()
    }
  }

  async addGiftDiscounts() {
    const existingCodes = this.cart.discountCodes?.map(dc => dc.code) || []
    const discountCodes = [
      ...new Set([...existingCodes, ...this.GIFT_DISCOUNTS])
    ]

    await this.setDiscountCodes(discountCodes)
  }

  async removeGiftDiscounts() {
    const existingCodes = this.cart.discountCodes?.map(dc => dc.code) || []
    const discountCodes = existingCodes.filter(
      code => !this.GIFT_DISCOUNTS.includes(code)
    )

    await this.setDiscountCodes(discountCodes)
    await this.fetchCart()
  }

  isValidGiftEmail(email) {
    // Use the same validation as other gift email fields in the codebase
    // Simple RFC 5322 compliant regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  isGiftFormValidForCheckout() {
    if (!this.hasGiftCheckboxTarget || !this.giftCheckboxTarget.checked) return true
    if (!this.hasGiftEmailTarget) return false
    const email = this.giftEmailTarget.value.trim()
    return !!email && this.isValidGiftEmail(email)
  }

  close() {
    this.sidecartTarget.dataset.open = false
    this.overlayTarget.classList.add("hidden")
    this.dispatchCartUpdatedEvent()

    // Wait for the animation to finish then hide the whole element
    setTimeout(() => {
      this.element.classList.add("hidden")
    }, 300)
  }

  open(openedFrom = null) {
    this.element.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    this.prepareAndFireCartViewedEvent(openedFrom)

    // Slight delay to ensure the opening animation plays
    setTimeout(() => {
      this.sidecartTarget.dataset.open = true
      this.dispatchCartUpdatedEvent()
    }, 10)
  }

  scrollToTop() {
    this.scrollableContainerTarget.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  someItemsAreSubscription() {
    return this.cart.lines.nodes.some(
      item => item.sellingPlanAllocation?.sellingPlan
    )
  }

  updateStepperOutlet() {
    if (this.hasSidecartStepperOutlet) {
      this.sidecartStepperOutlet.currentItemsInCartValue = this.cart.totalQuantity
      this.sidecartStepperOutlet.currentCartAmountValue =  this.cart.cost.subtotalAmount.amount
      this.sidecartStepperOutlet.subscriptionStateValue = this.someItemsAreSubscription()
      this.sidecartStepperOutlet.bundleStateValue = this.hasBundleItems()
      this.sidecartStepperOutlet.hideStepperValue = this.cartContainsSmallBundleItem()
    }
  }

  updateRecommendationsOutlet() {
    if (this.hasSidecartRecommendationsOutlet) {
      this.sidecartRecommendationsOutlet.subscriptionStateValue = this.someItemsAreSubscription()
    }
  }

  dispatchCartUpdatedEvent() {
    const event = {
      detail: {
        totalQuantity: this.cart?.totalQuantity || 0,
        open: this.sidecartTarget.dataset.open,
        hasSmallBundleItem: this.cartContainsSmallBundleItem(),
      },
      prefix: null
    }
    this.dispatch('sidecartUpdated', event)
  }

  prepareAndFireCartViewedEvent(openedFrom = null) {
    const cart = this.cart

    if (!cart || cart.lines?.nodes?.length === 0) { return }

    const items = cart.lines.nodes.map(item => {
      const product = item.merchandise.product

      return {
        line_item_id: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.id),
        sku: item.merchandise.sku,
        variant_id: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(item.merchandise.id),
        quantity: item.quantity,
        product_id: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(product.id),
        category: product.productType,
        line_subtotal: parseFloat(item.cost.subtotalAmount.amount) * 100,
        unit_price: parseFloat(item.cost.amountPerQuantity.amount) * 100,
      }
    })

    const appliedPromotions = cart.discountCodes?.map(dc => ({
      code: dc.code,
      discount_type: 'discount_code',
      scope: 'cart'
    })) || []

    ;(0,_core_google_analytics_events__WEBPACK_IMPORTED_MODULE_4__.fireCartViewedEvent)(
      cart.id,
      cart.totalQuantity,
      Math.round(parseFloat(cart.cost.subtotalAmount.amount) * 100),
      Math.round(parseFloat(cart.cost.totalAmount.amount) * 100),
      appliedPromotions,
      items,
      openedFrom,
    )
  }

  prepareAndFireCartItemQuantityUpdatedEvent(originalItem, newQuantity) {
    const updatedItem = this.cart.lines.nodes.find(item => item.id === originalItem.id)
    if (!updatedItem) {
      return // Item not found in updated cart
    }

    const product = updatedItem.merchandise.product

    ;(0,_core_google_analytics_events__WEBPACK_IMPORTED_MODULE_4__.fireCartItemQuantityUpdatedEvent)(
      this.cart.id,
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(updatedItem.id),
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(product.id),
      updatedItem.merchandise.sku,
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(updatedItem.merchandise.id),
      originalItem.quantity, // previous quantity
      newQuantity, // new quantity
      'user_edit', // reason
      Math.round(parseFloat(updatedItem.cost.amountPerQuantity.amount) * 100), // unit price in cents
      Math.round(parseFloat(updatedItem.cost.subtotalAmount.amount) * 100), // line subtotal in cents
      'USD' // currency
    )
  }

  prepareAndFireCartItemRemovedEvent(originalItem, reason) {
    const product = originalItem.merchandise.product

    ;(0,_core_google_analytics_events__WEBPACK_IMPORTED_MODULE_4__.fireCartItemRemovedEvent)(
      this.cart.id,
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(originalItem.id),
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(product.id),
      originalItem.merchandise.sku,
      (0,_customer_utils__WEBPACK_IMPORTED_MODULE_6__.ensureNoGid)(originalItem.merchandise.id),
      originalItem.quantity, // quantity being removed
      Math.round(parseFloat(originalItem.cost.amountPerQuantity.amount) * 100), // unit price in cents
      Math.round(parseFloat(originalItem.cost.subtotalAmount.amount) * 100), // line subtotal in cents
      'USD', // currency
      reason // reason for removal
    )
  }
}

Stimulus.register("sidecart", SidecartController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(8232)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);